







import { Vue, Component, Prop } from 'vue-property-decorator';

import DetailedSlotGeneric from './DetailedSlotGeneric.vue';

import { VacationSlot } from '../types';

import { formatDateInterval } from '../utils';

@Component({
    components: {
        DetailedSlotGeneric,
    },
})
export default class SlotVacation extends Vue {
    @Prop() event!: VacationSlot

    get dates() {
        return formatDateInterval(this.event.dates);
    }
}
